import { AlertError } from "./Helper";

export const UserRight = {
  CanAdd: 1,
  CanEdit: 2,
  CanDelete: 3,
  CanPrint: 4,
  Admin: 5,
  Supervisor: 6,
  CanEditReport: 7,
  CanViewReport: 8,
  CanApproveDF: 9,
  CanScheduleRadiologist: 10,
};
export const UserRightChecker = (userRule, userRight) => {
  // console.log(userRule);
  if (userRight === UserRight.CanAdd && userRule.flag_add === "y") return true;
  if (userRight === UserRight.CanEdit && userRule.flag_edit === "y")
    return true;
  if (userRight === UserRight.CanDelete && userRule.flag_delete === "y")
    return true;
  if (userRight === UserRight.CanPrint && userRule.flag_print === "y")
    return true;
  if (userRight === UserRight.Admin && userRule.flag_admin === "y") return true;
  if (userRight === UserRight.Supervisor && userRule.flag_super === "y")
    return true;

  if (userRight === UserRight.CanApproveDF && userRule.flag_df_approve === "y")
    return true;

  if (
    userRight === UserRight.CanScheduleRadiologist &&
    userRule.flag_radi_scheduler === "y"
  )
    return true;

  // default
  return false;
};

export const IsCanDelete = (userRule, dispatch) => {
  let ret = UserRightChecker(userRule, UserRight.CanDelete);
  if (!ret) {
    AlertError("ไม่ได้รับสิทธิให้ยกเลิกข้อมูล", dispatch);
  }
  return ret;
};

export const IsCanAdd = (userRule, dispatch) => {
  let ret = UserRightChecker(userRule, UserRight.CanAdd);
  if (!ret) {
    AlertError("ไม่ได้รับสิทธิให้เพิ่มข้อมูล", dispatch);
  }
  return ret;
};

export const IsCanEdit = (userRule, dispatch) => {
  let ret = UserRightChecker(userRule, UserRight.CanEdit);
  if (!ret) {
    AlertError("ไม่ได้รับสิทธิให้ทำการแก้ไข", dispatch);
  }
  return ret;
};

export const IsCanApprove = (userRule, dispatch) => {
  let ret = UserRightChecker(userRule, UserRight.CanApproveDF);
  if (!ret) {
    AlertError("ไม่ได้รับสิทธิ", dispatch);
  }
  return ret;
};
